import useLocalization from "../../../hooks/use-localization";
import { Link } from "react-router-dom";

export default function PostTiny({ post }) {

    const localization = useLocalization();

    if (!post) { return; }

    const postPath = `/post/${post.id}`;

    return (
        <div className="post-tiny">
            <img src={post.topImage} alt={post.title}></img>
            <div className="post-tiny-content">
                <span className="post-tiny-title">{post.title}</span>
                <span>{post.topContent}</span>
                <span className="post-tiny-link">
                    <Link to={postPath}>{localization.details}</Link>
                </span>
            </div>
        </div>
    );
}